import './Button.scss';

const Button = ({ children, onClick, type, className = 'default-button' }) => (
  <button
    className={className}
    type={type === 'submit' ? 'submit' : 'button'}
    onClick={onClick}
  >
    {children}
  </button>
);

export default Button;
